import { render, staticRenderFns } from "./module_b.vue?vue&type=template&id=40454fde&scoped=true&"
import script from "./module_b.vue?vue&type=script&lang=js&"
export * from "./module_b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40454fde",
  null
  
)

export default component.exports